import db from "../dexie-db/db";
import { generateSyncBoxId } from "./utils";
export default class SyncBoxConfig {
    async saveConfig(config) {
        await db.syncBoxConfig.put({
            ...config,
            id: generateSyncBoxId(config),
        });
    }
    static async getAllConfigs() {
        return await db.syncBoxConfig.toArray();
    }
    static async markForDeletion(syncBoxId) {
        await db.syncBoxConfig.update(syncBoxId, {
            markedForDeletion: true,
        });
    }
    static async getConfigsMarkedForDeletion() {
        return await db.syncBoxConfig
            .filter(config => config.markedForDeletion === true)
            .toArray();
    }
    static async delete(syncBoxId) {
        await db.syncBoxConfig.delete(syncBoxId);
    }
}
